import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
} from "reactstrap";
import {
  getCustomers,
  resetCustomers,
  resetBulkLoad,
  bulkLoadCustomer,
} from "../../../../store/customer/actions";
import {
  DataTable,
  TableRowField,
  ExportCSV,
  ImportCVS,
  MainLoader,
} from "../../../../components";
import { layout } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import { getExport as allCustomersExport } from "../../../../service/customer";
import { formatHelper } from "../../../../common/helpers";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { exportExcel } from "./excel";
class CustomerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      loadingExport: false,
      fileUploadOpen: false,
    };
    this.handleObtainCustomersExport =
      this.handleObtainCustomersExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.checkBulkLoad = this.checkBulkLoad.bind(this);
    this.onSubmitBulkLoad = this.onSubmitBulkLoad.bind(this);
  }

  componentDidMount() {
    this.performGetCustomers(true);
  }
  componentWillUnmount() {
    this.props.resetCustomers();
  }
  componentDidUpdate(prevProps) {
    this.checkBulkLoad(prevProps);
  }

  async checkBulkLoad(prevProps) {
    if (!prevProps.bulkLoadValue && this.props.bulkLoadValue) {
      const wb = XLSX.read(this.props.bulkLoadValue.data, { type: "binary" });
      XLSX.writeFile(wb, "Clientes_Resultados.xlsx");

      toast.success("Carga masiva realizada con éxito");
      await this.setState({ page: 1, fileUploadOpen: false });
      this.performGetCustomers();
    } else if (!prevProps.bulkLoadError && this.props.bulkLoadError)
      toast.error(this.props.bulkLoadError);
  }

  performGetCustomers(reset = false) {
    const { page, filter } = this.state;
    this.props.getCustomers({ page, filter, reset });
  }

  async filterCustomers() {
    await this.setState({ page: 1 });
    this.performGetCustomers();
  }

  onSubmitBulkLoad(file) {
    this.props.bulkLoadCustomer(file);
  }

  handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterCustomers();
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetCustomers();
  }

  optionsFormatterColumn(cell, row) {
    return (
      <Button
        type="button"
        color="primary"
        size="sm"
        onClick={() =>
          this.props.history.push(`/administration/customers/${row.id}/detail`)
        }
      >
        <i className="fa fa-eye" />
      </Button>
    );
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.customers}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainCustomersExport() {
    this.setState({
      loadingExport: true,
    });
    allCustomersExport()
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => {
        this.setState({
          loadingExport: false,
        });
      });
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "id",
        text: "Cliente",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="Apellidos:" value={row.lastname} />
              <TableRowField label="DNI:" value={row.dni} />
              <TableRowField label="Email:" value={row.email} />
            </div>
          );
        },
      },
      columnOption,
    ];

    const columnsSM = [
      {
        dataField: "id",
        text: "Cliente",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="Apellidos:" value={row.lastname} />
              <TableRowField label="DNI:" value={row.dni} />
            </div>
          );
        },
      },
      {
        dataField: "email",
        text: "Email",
      },
      columnOption,
    ];

    const columns = [
      {
        dataField: "name",
        text: "Nombre",
      },
      {
        dataField: "lastname",
        text: "Apellidos",
      },
      {
        dataField: "dni",
        text: "DNI",
      },
      {
        dataField: "email",
        text: "Email",
      },
      columnOption,
    ];
    if (this.props.loading) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-people" />
            Clientes
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="8">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterCustomers()}
                            >
                              <i className="fa fa-search" />
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="2">
                        <div className="float-right">
                          <Button
                            style={{ marginRight: "2px" }}
                            color="primary"
                            onClick={() =>
                              this.setState({ fileUploadOpen: true })
                            }
                            disabled={this.props.bulkLoadLoading}
                          >
                            <i className="fa fa-upload mr-1" /> Carga masiva
                          </Button>
                        </div>
                      </Col>
                      <Col sm="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainCustomersExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col md="10">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterCustomers()}
                            >
                              <i className="fa fa-search" />
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="2">
                        <div className="float-right">
                          <Button
                            style={{ marginRight: "2px" }}
                            color="primary"
                            onClick={() =>
                              this.setState({ fileUploadOpen: true })
                            }
                            disabled={this.props.bulkLoadLoading}
                          >
                            <i className="fa fa-upload mr-1" /> Carga masiva
                          </Button>
                        </div>
                      </Col>
                      <Col md="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainCustomersExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columns)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <ImportCVS
          isOpen={this.state.fileUploadOpen}
          onSubmit={this.onSubmitBulkLoad}
          onCancel={() => this.setState({ fileUploadOpen: false })}
          disabled={this.props.bulkLoadLoading}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { customers, error, loading, pageSize, total } =
    state.customer.customerList;
  const { bulkLoad } = state.customer;

  return {
    customers,
    error,
    loading,
    pageSize,
    total,
    bulkLoadValue: bulkLoad.value,
    bulkLoadLoading: bulkLoad.loading,
    bulkLoadError: bulkLoad.error,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCustomers,
      resetCustomers,
      bulkLoadCustomer,
      resetBulkLoad,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Customer/CustomerList/CustomerList.js